import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { getUniqueKey } from '@tencent/glue-util-helper';
import { getElementSize } from '@tencent/glue-dom-boundary';
export var ResizeHandler = /*#__PURE__*/function () {
  function ResizeHandler() {
    var _this = this;

    _classCallCheck(this, ResizeHandler);

    this.domMap = {};
    this.dirty = {};
    this.timer = null;
    this.ob = new ResizeObserver(function (entries) {
      return _this.process(entries);
    });
  }

  _createClass(ResizeHandler, [{
    key: "addResizeListener",
    value: function addResizeListener(el, listener) {
      var id = getUniqueKey(el);
      var init = this.domMap[id] != null;
      var map = this.domMap[id] = this.domMap[id] || {
        el: el,
        listeners: []
      };
      map.listeners.push(listener);

      if (!init) {
        this.ob.observe(el);
      }
    }
  }, {
    key: "removeResizeListener",
    value: function removeResizeListener(el, listener) {
      var id = getUniqueKey(el);
      var map = this.domMap[id];

      if (!map) {
        return;
      }

      if (!listener) {
        delete this.domMap[id];
        this.ob.unobserve(el);
      }

      map.listeners = map.listeners.filter(function (item) {
        return item !== listener;
      });

      if (!map.listeners.length) {
        delete this.domMap[id];
        this.ob.unobserve(el);
      }
    }
  }, {
    key: "process",
    value: function process(entries) {
      var _this2 = this;

      entries.forEach(function (item) {
        return _this2.dirty[getUniqueKey(item.target)] = true;
      });

      if (this.timer != null) {
        return;
      }

      this.timer = requestAnimationFrame(function () {
        _this2.timer = null;

        _this2.dispatch();
      });
    }
  }, {
    key: "dispatch",
    value: function dispatch() {
      var _this3 = this;

      var dirty = this.dirty;
      this.dirty = {};
      Object.keys(dirty).forEach(function (id) {
        var map = _this3.domMap[id];

        if (!map) {
          return;
        }

        var size = getElementSize(map.el);
        map.listeners.forEach(function (item) {
          return item(size);
        });
      });
    }
  }], [{
    key: "support",
    value: function support() {
      return typeof ResizeObserver !== 'undefined';
    }
  }, {
    key: "addResizeListener",
    value: function addResizeListener(el, listener) {
      var handler = ResizeHandler.RESIZE_HANDLER = ResizeHandler.RESIZE_HANDLER || new ResizeHandler();
      handler.addResizeListener(el, listener);
    }
  }, {
    key: "removeResizeListener",
    value: function removeResizeListener(el, listener) {
      var handler = ResizeHandler.RESIZE_HANDLER;

      if (handler == null) {
        return;
      }

      handler.removeResizeListener(el, listener);
    }
  }]);

  return ResizeHandler;
}();
ResizeHandler.RESIZE_HANDLER = null;